// Auto-generated tokens file - do not edit manually

export const tokens = {
  "colors": {
    "neutral": {
      "white": "#ffffff",
      "black": "#000000",
      "grey": {
        "100": "#f8f8fc",
        "200": "#e9ecef",
        "300": "#dee2e6",
        "400": "#ced4da",
        "500": "#adb5bd",
        "600": "#6c757d",
        "700": "#495057",
        "800": "#343a40",
        "900": "#1d1d1d",
        "Alpha": {
          "5": "#1d1d1d0d",
          "10": "#1d1d1d1a",
          "black": "#0000001a"
        }
      }
    },
    "states": {
      "success": {
        "50": "#f5fbf7",
        "100": "#ecf7f0",
        "200": "#d0eadb",
        "300": "#b4ddc6",
        "400": "#83c9a2",
        "500": "#43b275",
        "600": "#3ca069",
        "700": "#368e5e",
        "800": "#2f7d52",
        "900": "#296b46",
        "default": "#43b275"
      },
      "info": {
        "50": "#f5fcfc",
        "100": "#ebf8f8",
        "200": "#d2eded",
        "300": "#b8e1e3",
        "400": "#89d0d3",
        "500": "#3bb4c2",
        "600": "#35a2ae",
        "700": "#2f909b",
        "800": "#297e87",
        "900": "#236c74",
        "default": "#3bb4c2"
      },
      "alert": {
        "50": "#fcf5f6",
        "100": "#f9ecee",
        "200": "#f0d2d7",
        "300": "#e6b8c0",
        "400": "#d78997",
        "500": "#c43e51",
        "600": "#b13849",
        "700": "#9e3241",
        "800": "#8a2c39",
        "900": "#772631",
        "default": "#c43e51"
      },
      "warning": {
        "50": "#fffaf6",
        "100": "#fff4ea",
        "200": "#fee4cb",
        "300": "#fdd3ad",
        "400": "#fbb77a",
        "500": "#f78f32",
        "600": "#de812d",
        "700": "#c67228",
        "800": "#ad6423",
        "900": "#95551e",
        "default": "#f78f32"
      }
    },
    "brand": {
      "plum-orchid": {
        "50": "#fbf6fa",
        "100": "#f6edf5",
        "200": "#e9d1e6",
        "300": "#dcb6d7",
        "400": "#c27fb9",
        "500": "#a8489b",
        "600": "#97418c",
        "700": "#863a7c",
        "800": "#76326c",
        "900": "#652b5d"
      },
      "blue": {
        "50": "#f4f7fb",
        "100": "#eaf0f7",
        "200": "#cbd9ea",
        "300": "#adc3dc",
        "400": "#769ad0",
        "500": "#2d64ad",
        "600": "#295a9c",
        "700": "#244f8a",
        "800": "#1f4679",
        "900": "#1b3c68"
      },
      "aie-blue": {
        "50": "#f4f5f7",
        "100": "#e9eaf0",
        "200": "#c8cbd8",
        "300": "#a7acc1",
        "400": "#656e92",
        "500": "#233064",
        "600": "#202b5a",
        "700": "#1c2650",
        "800": "#182246",
        "900": "#151d3c"
      },
      "veld-sprout": {
        "50": "#f9fcf6",
        "100": "#f3f9ea",
        "200": "#e2f0ce",
        "300": "#d1e8b2",
        "400": "#c1df90",
        "500": "#b4d772",
        "600": "#a2c167",
        "700": "#90ac5c",
        "800": "#7e9650",
        "900": "#6c8145"
      },
      "fresh-green": {
        "50": "#f5fbf7",
        "100": "#ecf7f0",
        "200": "#d0eadb",
        "300": "#b4ddc6",
        "400": "#83c9a2",
        "500": "#43b275",
        "600": "#3ca069",
        "700": "#368e5e",
        "800": "#2f7d52",
        "900": "#296b46"
      },
      "tide-blue": {
        "50": "#f5fcfc",
        "100": "#ebf8f8",
        "200": "#d2eded",
        "300": "#b8e1e3",
        "400": "#89d0d3",
        "500": "#3bb4c2",
        "600": "#35a2ae",
        "700": "#2f909b",
        "800": "#297e87",
        "900": "#236c74"
      },
      "red": {
        "50": "#fcf5f6",
        "100": "#f9ecee",
        "200": "#f0d2d7",
        "300": "#e6b8c0",
        "400": "#d78997",
        "500": "#c43e51",
        "600": "#b13849",
        "700": "#9e3241",
        "800": "#8a2c39",
        "900": "#772631"
      },
      "burnt-orange": {
        "50": "#fff8f7",
        "100": "#fef0ee",
        "200": "#fbd5ce",
        "300": "#f8b9ad",
        "400": "#f4856e",
        "500": "#f15a38",
        "600": "#d95132",
        "700": "#c1482d",
        "800": "#a93e27",
        "900": "#913522"
      },
      "naartjie": {
        "50": "#fffaf6",
        "100": "#fff4ea",
        "200": "#fee4cb",
        "300": "#fdd3ad",
        "400": "#fbb77a",
        "500": "#f78f32",
        "600": "#de812d",
        "700": "#c67228",
        "800": "#ad6423",
        "900": "#95551e"
      },
      "karoo-gold": {
        "50": "#fefcf5",
        "100": "#fdf9eb",
        "200": "#f9f1d2",
        "300": "#f6e9b8",
        "400": "#f0d97d",
        "500": "#e7c21f",
        "600": "#d0af1c",
        "700": "#b99b19",
        "800": "#a28716",
        "900": "#8b7413"
      }
    },
    "surfaces": {
      "page-background": "#f8f8fc",
      "container-background": "#ffffff",
      "border-divider": "#dee2e6",
      "shadow": "#1d1d1d0d"
    },
    "text": {
      "primary": "#1d1d1d",
      "secondary": "#6c757d",
      "disabled": "#adb5bd",
      "link": "#2d64ad"
    },
    "ui": {
      "background": "#ffffff",
      "foreground": "#1d1d1d",
      "card": "#ffffff",
      "card-foreground": "#343a40",
      "popover": "#ffffff",
      "popover-foreground": "#343a40",
      "primary": "#233064",
      "primary-foreground": "#ffffff",
      "secondary": "#3bb4c2",
      "secondary-foreground": "#ffffff",
      "muted": "#e9ecef",
      "muted-foreground": "#343a40",
      "accent": "#f8f8fc",
      "accent-foreground": "#1d1d1d",
      "destructive": "#c43e51",
      "border": "#dee2e6",
      "input": "#dee2e6",
      "ring": "#3bb4c2",
      "chart-1": "#2d64ad",
      "chart-2": "#a8489b",
      "chart-3": "#e7c21f",
      "chart-4": "#f78f32",
      "chart-5": "#b4d772",
      "sidebar": "#ffffff",
      "sidebar-foreground": "#343a40",
      "sidebar-primary": "#3bb4c2",
      "sidebar-primary-foreground": "#ffffff",
      "sidebar-accent": "#f5fcfc",
      "sidebar-accent-foreground": "#343a40",
      "sidebar-border": "#dee2e6",
      "sidebar-ring": "#3bb4c2"
    },
    "ui-dark": {
      "background": "#1d1d1d",
      "foreground": "#ffffff",
      "card": "#343a40",
      "card-foreground": "#ffffff",
      "popover": "#343a40",
      "popover-foreground": "#ffffff",
      "primary": "#3bb4c2",
      "primary-foreground": "#ffffff",
      "secondary": "#f78f32",
      "secondary-foreground": "#f8f8fc",
      "muted": "#343a40",
      "muted-foreground": "#adb5bd",
      "accent": "#495057",
      "accent-foreground": "#f8f8fc",
      "destructive": "#c43e51",
      "border": "#495057",
      "input": "#495057",
      "ring": "#3bb4c2",
      "chart-1": "#3bb4c2",
      "chart-2": "#3bb4c2",
      "chart-3": "#2d64ad",
      "chart-4": "#a8489b",
      "chart-5": "#e7c21f",
      "sidebar": "#343a40",
      "sidebar-foreground": "#f8f8fc",
      "sidebar-primary": "#3bb4c2",
      "sidebar-primary-foreground": "#1d1d1d",
      "sidebar-accent": "#495057",
      "sidebar-accent-foreground": "#f8f8fc",
      "sidebar-border": "#495057",
      "sidebar-ring": "#3bb4c2"
    },
    "theme": {
      "topbar-color": "var(--topbar-color)",
      "sidebar-color": "var(--sidebar-color)",
      "highlight-color": "var(--highlight-color)",
      "hover-color": "var(--hover-color)",
      "active-color": "var(--active-color)",
      "login-header-color": "var(--login-header-color)",
      "button-color": "var(--button-color)",
      "button-hover-color": "var(--button-hover-color)",
      "button-active-color": "var(--button-active-color)"
    }
  },
  "typography": {
    "fontFamilies": {
      "segoe-ui": "Albert Sans",
      "albert-sans": "Albert Sans"
    },
    "lineHeights": {
      "100": "100%",
      "110": "110%",
      "130": "130%"
    },
    "fontWeights": {
      "bold": 700,
      "semibold": 600,
      "regular": 400,
      "medium": 500,
      "light": 300
    },
    "fontSize": {
      "xs-8px": "8px",
      "sm-10px": "10px",
      "md-12px": "12px",
      "lg-14px": "14px",
      "base-16px": "16px",
      "xl-18px": "18px",
      "2xl-20px": "20px",
      "3xl-24px": "24px",
      "4xl-32px": "32px"
    },
    "Heading": {
      "display": {
        "fontFamily": "Albert Sans",
        "fontWeight": 600,
        "lineHeight": "130%",
        "fontSize": "32px"
      },
      "heading-1": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "130%",
        "fontSize": "24px"
      },
      "heading-2": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "130%",
        "fontSize": "20px"
      },
      "heading-3": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "130%",
        "fontSize": "18px"
      },
      "heading-4": {
        "fontFamily": "Albert Sans",
        "fontWeight": 600,
        "lineHeight": "130%",
        "fontSize": "16px"
      },
      "heading-5": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "130%",
        "fontSize": "16px"
      },
      "heading-6": {
        "fontFamily": "Albert Sans",
        "fontWeight": 600,
        "lineHeight": "130%",
        "fontSize": "16px"
      }
    },
    "body-normal": {
      "Regular": {
        "fontFamily": "Albert Sans",
        "fontWeight": 400,
        "lineHeight": "110%",
        "fontSize": "16px"
      },
      "Bold": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "110%",
        "fontSize": "16px"
      }
    },
    "body-small": {
      "Regular": {
        "fontFamily": "Albert Sans",
        "fontWeight": 400,
        "lineHeight": "110%",
        "fontSize": "14px"
      },
      "Bold": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "110%",
        "fontSize": "14px"
      }
    },
    "label-normal": {
      "Regular": {
        "fontFamily": "Albert Sans",
        "fontWeight": 400,
        "lineHeight": "100%",
        "fontSize": "12px"
      },
      "Semibold": {
        "fontFamily": "Albert Sans",
        "fontWeight": 600,
        "lineHeight": "100%",
        "fontSize": "12px"
      },
      "Bold": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "lineHeight": "100%",
        "fontSize": "12px"
      }
    },
    "label-small": {
      "Regular": {
        "fontFamily": "Albert Sans",
        "fontWeight": 400,
        "fontSize": "10px",
        "lineHeight": "100%"
      },
      "Semibold": {
        "fontFamily": "Albert Sans",
        "fontWeight": 600,
        "fontSize": "10px",
        "lineHeight": "100%"
      },
      "Bold": {
        "fontFamily": "Albert Sans",
        "fontWeight": 700,
        "fontSize": "10px",
        "lineHeight": "100%"
      }
    }
  },
  "effects": {
    "effects": {
      "shadow": {
        "default": "0px 1px 2px 0px #1d1d1d0d",
        "hover": "0px 3px 6px -2px #1d1d1d1a",
        "drawer": "1px 0px 20px -3px #1d1d1d0d"
      },
      "backdrop-blur-12": "blur(12px)",
      "backdrop-blur-40": "blur(40px)"
    }
  },
  "globals": {
    "border-radius": "10px",
    "font-family": "Albert Sans",
    "spacing-0": "0",
    "spacing-px": "1px",
    "spacing-0-5": "0.125rem",
    "spacing-1": "0.25rem",
    "spacing-1-5": "0.375rem",
    "spacing-2": "0.5rem",
    "spacing-2-5": "0.625rem",
    "spacing-3": "0.75rem",
    "spacing-3-5": "0.875rem",
    "spacing-4": "1rem",
    "spacing-5": "1.25rem",
    "spacing-6": "1.5rem",
    "spacing-7": "1.75rem",
    "spacing-8": "2rem",
    "spacing-9": "2.25rem",
    "spacing-10": "2.5rem",
    "spacing-11": "2.75rem",
    "spacing-12": "3rem",
    "spacing-14": "3.5rem",
    "spacing-16": "4rem",
    "spacing-20": "5rem",
    "spacing-24": "6rem",
    "spacing-28": "7rem",
    "spacing-32": "8rem",
    "spacing-36": "9rem",
    "spacing-40": "10rem",
    "spacing-44": "11rem",
    "spacing-48": "12rem",
    "spacing-52": "13rem",
    "spacing-56": "14rem",
    "spacing-60": "15rem",
    "spacing-64": "16rem",
    "spacing-72": "18rem",
    "spacing-80": "20rem",
    "spacing-96": "24rem",
    "spacing-sm": "0.5rem",
    "spacing-md": "1rem",
    "spacing-lg": "1.25rem",
    "spacing-xl": "1.5rem",
    "spacing-2xl": "1.75rem"
  }
};